<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {},
		provide() {
			return {

			}
		},
		data() {
			return {
				visible: true
			}
		},
		methods: {
			close() {
				this.visible = false;
			}
		},
		created() {
			document.addEventListener('plusready', function() {
				plus.key.addEventListener('27', "keydown", function() {
					alert("BackButton Key pressed!");
				});
			}, false)
		}
	}
</script>

<style lang="scss">
	body {
		margin: 0px;
		padding: 0px;
		font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
		font-size: 14px;
		-webkit-font-smoothing: antialiased;
	}

	a {
		text-decoration: none
	}

	ul {
		padding-left: 0px
	}

	#app {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
	}

	.el-submenu [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}

	.el-menu-item [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}

	.toolbar {
		background: #f2f2f2;
		padding: 10px;
		margin: 10px 0px;

		.el-form-item {
			margin-bottom: 10px;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all .2s ease;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	.fork-me-github {
		position: absolute;
		top: 0;
		right: 0;
		border: 0;
	}

	.alipay-adv {
		position: fixed;
		right: 20px;
		bottom: 0;
		width: 300px;
		height: auto;
	}

	.alipay-adv img {
		width: 100%;
	}

	.close-adv {
		position: absolute;
		right: 8px;
		top: -15px;
		background: #fff;
		padding: 0 5px;
		font-size: 12px;
		cursor: pointer;
	}

	.el-message-box__close,
	.el-dialog__headerbtn {
		display: none !important
	}

	.el-dialog__body {
		padding:10px 10px 30px 10px!important;
	}

	/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	/*定义滚动条轨道 内阴影+圆角*/
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		border-radius: 3px;
		background-color: #f0f0f0;
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
		background-color: #c1c1c1;
	}
</style>



// WEBPACK FOOTER //
// App.vue?1a6193dd